<template>
  <div class="container-card el-row">
    <el-row>
      <el-col class="mr20" :xl="20" :span="24">
        <el-card>
          <div class="flex-space-between">
            <div class="flex-center">
              <div class="wallet-label">
                <p>
                  Dollar<br />
                  Balance
                </p>
                <hr />
                <p>
                  VidCents<br />
                  Balance
                </p>
              </div>
              <div class="border-vertical"></div>
              <div class="wallet-amount">
                <div class="flex-start">
                  <span>$</span>
                  <p>{{ data.dollar }}</p>
                </div>
                <hr />
                <div class="flex-start">
                  <img id="vc" src="@/assets/images/vc.svg" alt="" />
                  <p>{{ data.vidCents }}</p>
                </div>
              </div>
            </div>
            <TopUpDialog />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="14">
        <el-card class="data" v-loading="loading">
          <div class="data-title" slot="header">
            <img
              class="report-img"
              src="@/assets/images/monitoring.svg"
              alt=""
            />
            <span>CAMPAIGNS</span>
            <el-button
              type="primary"
              class="btn-white float-right ml-auto"
              @click="openCampaignDialog()"
            >
              + Create campaign
            </el-button>
            <CampaignDialog />
            <CampaignDeposit />
          </div>
          <CampaignTable />
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card v-loading="loading">
          <div slot="header" class="align-left">
            <span class="title">Tracks</span>
            <TrackDialog />
            <TrackDeposit />
          </div>
          <TrackTable />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import CampaignDialog from '../components/campaign/Dialog'
import CampaignDeposit from '../components/campaign/Deposit'
import CampaignTable from '../components/campaign/Table'
import TrackDialog from '../components/track/Dialog'
import TrackDeposit from '../components/track/Deposit'
import TrackTable from '../components/track/Table'
import TopUpDialog from '../components/TopUpDialog'

export default {
  components: {
    CampaignDialog,
    CampaignDeposit,
    CampaignTable,
    TrackDialog,
    TrackDeposit,
    TrackTable,
    TopUpDialog
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapState('labelVidCents', ['loading']),
    ...mapState('labelVidCents', ['data'])
  },

  methods: {
    ...mapMutations('labelVidCents', ['setCampaign', 'setDialogCampaign']),
    ...mapMutations('labelTrackVidCents', ['setTrack', 'setTrackDialog']),
    ...mapActions('labelVidCents', ['getBalance', 'readCampaign']),

    openCampaignDialog() {
      this.setDialogCampaign(true)
      this.setCampaign({})
    },

    openTrackDialog() {
      this.setTrackDialog(true)
      this.setTrack({})
    }
  },

  created() {
    this.getBalance()
    this.readCampaign()
  }
}
</script>

<style scoped>
.el-card__body {
  padding: 20px !important;
}
</style>
